// Dashboard API service functions
import { createApiClient } from '../utils/apiClient'

// Service class for dashboard-related API calls
export class DashboardService {
  constructor(getAuthToken, onUnauthorized = null) {
    this.apiClient = createApiClient(getAuthToken, onUnauthorized)
  }

  // Get comprehensive dashboard data
  async getDashboardData() {
    try {
      const response = await this.apiClient.get('/dashboard')
      return response
    } catch (error) {
      console.error('Failed to fetch dashboard data:', error)
      throw error
    }
  }

  // Create new API key
  async createApiKey(keyName) {
    try {
      const response = await this.apiClient.post('/api-keys', { keyName })
      return response
    } catch (error) {
      console.error('Failed to create API key:', error)
      throw error
    }
  }

  // Revoke API key
  async revokeApiKey(keyId) {
    try {
      const response = await this.apiClient.delete('/api-keys', { keyId })
      return response
    } catch (error) {
      console.error('Failed to revoke API key:', error)
      throw error
    }
  }

  // List API keys
  async getApiKeys() {
    try {
      const response = await this.apiClient.get('/api-keys')
      return response
    } catch (error) {
      console.error('Failed to fetch API keys:', error)
      throw error
    }
  }

  // Generate icons
  async generateIcons(iconData) {
    try {
      const response = await this.apiClient.post('/generate', iconData)
      return response
    } catch (error) {
      console.error('Failed to generate icons:', error)
      throw error
    }
  }

  // Get billing information
  async getBilling() {
    try {
      const response = await this.apiClient.get('/billing')
      return response
    } catch (error) {
      console.error('Failed to fetch billing data:', error)
      throw error
    }
  }

  // Create Stripe Customer Portal session
  async createStripePortalSession() {
    try {
      const response = await this.apiClient.post('/stripeSession')
      return response
    } catch (error) {
      console.error('Failed to create Stripe portal session:', error)
      throw error
    }
  }

  // Delete user account
  async deleteAccount(captchaToken) {
    try {
      const response = await this.apiClient.delete('/account', { captchaToken })
      return response
    } catch (error) {
      console.error('Failed to delete account:', error)
      throw error
    }
  }
}

// Factory function to create dashboard service instance
export const createDashboardService = (getAuthToken, onUnauthorized = null) => {
  return new DashboardService(getAuthToken, onUnauthorized)
}

// Export individual service functions for convenience
export const dashboardApi = {
  getDashboardData: (apiClient) => apiClient.get('/dashboard'),
  createApiKey: (apiClient, keyName) => apiClient.post('/api-keys', { keyName }),
  revokeApiKey: (apiClient, keyId) => apiClient.delete('/api-keys', { keyId }),
  getApiKeys: (apiClient) => apiClient.get('/api-keys'),
  generateIcons: (apiClient, iconData) => apiClient.post('/generate', iconData),
  getBilling: (apiClient) => apiClient.get('/billing'),
  deleteAccount: (apiClient, captchaToken) => apiClient.delete('/account', { captchaToken }),
}
